import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { submissionsApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import closeIcon from '../../../../assests/admin/guide/closeIcon.png'
import Project from "../../Projects/Project";
import classes from './ProjectGuide.module.css'

const ProjectGuide = () => {

    const [data, setData] = useState()
    const { texts, lang } = useSelector(state => state.translate);
    const dispatch = useDispatch()
    let { submissionId } = useParams();

    useEffect(() => {
        const data = {
            submissionId,
            showPendingMsg: false
        }

        submissionsApi.submissionsFilterPost({ submissionsFilter: data }, (error, resdata, response) => {
            if (error)
                dispatch(throwApiError({ userMessage: texts.submissionsFilterIdError, error: error, statusCode: response?.statusCode, message: "submissionsFilterIdPost " + error.message, level: 2, component: "Submission", line: 22 }))
            else {
                const newbody = response.body
                if (response.body.contentData) {
                    const newAdditionalData = JSON.parse(newbody.contentData)
                    newbody.contentData = newAdditionalData
                }
                setData({ ...newbody });
                console.log('newbody!', newbody);
            }
        })

    }, [submissionId])

    function closeProject() {
        window.close();
        window.opener.focus();
    }

    return (
        <>
            <div className={classes.HeaderContainer}>
                <p className={classes.ProjectName}>{data && data.assessmentName}</p>
                <img className={classes.CloseIcon} src={closeIcon} alt="closeIcon" onClick={closeProject} />
            </div>
            {data && <Project attachmentUrl={`${data.attachmentUrl}`} ideUrl={data.ide?.url} ideConfig={data.ide?.additionalConfiguration} height="calc(100vh - 60px - 50px)" IdeLang={data.ide?.lang ? data.ide?.lang : lang}></Project>}

        </>
    )
}

export default ProjectGuide;